import Backdrop from "components/Backdrop";
import { AnimatePresence, motion } from "framer-motion";
import { FC, PropsWithChildren, useEffect } from "react";
import styles from "./SlideModal.module.scss";

export interface SlideModalProps {
  isOpen: boolean;
  onClose?: () => void;
}

const slideIn = {
  hidden: { y: "100%", opacity: 0 },
  visible: { y: "0", transition: { type: "tween" }, opacity: 1 },
  exit: { y: "100%", opacity: 0 },
};

const SlideModal: FC<PropsWithChildren<SlideModalProps>> = ({
  children,
  isOpen,
  onClose,
}) => {
  useEffect(() => {
    if (isOpen) {
      const prevOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";

      return () => {
        document.body.style.overflow = prevOverflow || "unset";
      };
    } else document.body.style.overflow = "unset";
  }, [isOpen]);

  return (
    <AnimatePresence mode="wait" initial={false} onExitComplete={() => null}>
      {isOpen && (
        <Backdrop onClick={onClose}>
          <motion.div
            onClick={(e) => e.stopPropagation()}
            variants={slideIn}
            initial="hidden"
            animate="visible"
            exit="exit"
            className={styles.slideModal}
          >
            {children}
          </motion.div>
        </Backdrop>
      )}
    </AnimatePresence>
  );
};

export default SlideModal;
